<template>
  <div class="container">
    <div class="getlocal" @click="getCurrentPosition(true)">
      <i class="el-icon-location"></i>
    </div>
    <div class="localHeight" v-if="showHeightIcon" @click="getlocalHeight()">
      <img src="../assets/height.png" style="width: 35px; height: 35px" />
    </div>
    <div id="distanceBox" v-if="showDistance">
      <div id="distance">
        <p>
          您当前距离此处
          <span id="dispart">{{ distance }}</span
          >米
        </p>
      </div>
    </div>
    <div>
      <div class="canceldistance" @click="canceldistance">
        <i class="el-icon-error"></i>
      </div>
    </div>
    <div id="map-container"></div>
    <!-- 瓦片区域显示的不同松树图标 -->
    <div style="opacity: 0">
      <img
        src="../assets/sh1.svg"
        ref="sh1"
        style="width: 25px; height: 25px"
      />
      <img
        src="../assets/sh2.svg"
        ref="sh2"
        style="width: 25px; height: 25px"
      />
      <img
        src="../assets/sh3.svg"
        ref="sh3"
        style="width: 25px; height: 25px"
      />
      <img
        src="../assets/sh4.svg"
        ref="sh4"
        style="width: 25px; height: 25px"
      />
    </div>
    <el-dialog :visible.sync="showHeight" class="heightContainer">
      <span>{{ tip }}</span>
    </el-dialog>
    <el-dialog
      :visible.sync="showChoice1"
      class="choiceContainer1"
      title="请选择导航方式"
      :before-close="cancelMarker"
    >
      <ul class="choice">
        <li id="gaode" @click="toGaode">高德地图</li>
        <li id="baidu" @click="toBaidu">百度地图</li>
      </ul>
      <div class="cancel">
        <span @click="cancelMarker">取消</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "underscore";
import mapboxgl from "mapbox-gl";
import MapboxElevation from "mapbox-elevation";
import { Toast, List } from "vant";
import MapboxLanguage from "@mapbox/mapbox-gl-language";
import { getUtrList, searchMarkInfo, getMapToken } from "../api/api";

export default {
  name: "mapbox",
  props: {
    markerList: {
      type: Object,
    },
    searchShow: {
      type: Boolean,
    },
    centerCo: {
      type: Array,
    },
  },
  watch: {
    markerList() {
      this.dataNode = this.markerList;
      this.renewMarker(this.dataNode);
    },
    // //监听上个页面是从/picdetail返回的还是从/framework回退，val是true表示是从/picdetail返回画线
    // //false直接把线清掉
    "$store.state.position": function (val) {
      if (val === true) {
        this.addline(this.lng, this.lat, this.lng2, this.lat2); //划线
        this.getDistance(this.lat, this.lng, this.lat2, this.lng2); //获取距离
        this.showDistance = true;
      } else {
        this.removeline();
      }
    },
    centerCo() {
      this.mapInstant.setCenter(this.centerCo);
    },
  },

  data() {
    return {
      showChoice1: false,
      dataNode: {},
      lat: 0, //手机纬度
      lng: 0, //手机经度
      altitude: "", //手机海拔
      difference: "", //海拔高度差
      lat1: null,
      lat2: null,
      lng1: null,
      lng2: null,
      curDeg: 0,
      mapInstant: null,
      marker: null,
      markerHeight: "",
      curLayers: [],
      curSource: [],
      svgflag: true,
      mymark: null, //自定义的箭头图标
      mymarkobj: null, //箭头坐标的框对象
      markerTagObject: null, //mark对象
      showDistance: false, //页面下方的距离显示
      distance: 0,
      canceldistance1: false,
      customizeMarker: "", //自定义标记,
      customizeMarkerArr: "",

      show: false,
      search: false,
      markerName: "",
      latitude: 29.166189,
      longitude: 107.053286,
      //postion设置
      options: {
        enableHighAccuracy: true,
        maximumAge: 10000,
      },
      accuracy: "",
      /***************************************************************************/
      geojson: {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [-121.415061, 40.506229],
              },
            },
          ],
        },
      },
      /***************************************************************************/
      EARTH_RADIUS: 6378137.0, //单位m
      PI: Math.PI,
      loading: true,
      showHeight: false,
      accessToken: "",
      tip: "",
      showHeightIcon: false,
    };
  },
  created() {
    document.documentElement.scrollTop = 0;
    this.initLocation();
  },
  methods: {
    toGaode() {
      let url = `amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat=${this.customizeMarkerArr[1]}&dlon=${this.customizeMarkerArr[0]}&dname=&dev=1&t=0`;
      window.location.href = url;
      setTimeout(() => {
        Toast.fail("手机未安装高德地图");
      }, 500);
    },
    toBaidu() {
      let url = `bdapp://map/direction?origin=name:我的位置|latlng:${this.lat},${this.lng}&destination=${this.customizeMarkerArr[1]},${this.customizeMarkerArr[0]}&mode=driving&coord_type=wgs84&region=广州&output=html`;
      window.location.href = url;
      setTimeout(() => {
        Toast.fail("手机未安装百度地图");
      }, 500);
    },
    goTest() {
      this.$router.push({
        path: "/test",
      });
    },
    //引入watchPostion函数
    initLocation() {
      console.log("initLocation");
      // navigator.geolocation.watchPosition(
      //   this.onSuccess,
      //   this.onError,
      //   this.options
      // );
      if (window.plus) {
        // 在 App 环境
        plus.geolocation.watchPosition((p) => {
          console.log("APP 定位:", p.coords.latitude, p.coords.longitude);
          this.lat = p.coords.latitude;
          this.lng = p.coords.longitude;
          this.accuracy = p.coords.accuracy;
          this.latitude = p.coords.latitude;
          this.longitude = p.coords.longitude;
          this.mymarkPosition(
            p.coords.longitude,
            p.coords.latitude,
          );
        });
      } else if ("geolocation" in navigator) {
        // 在浏览器环境
        navigator.geolocation.getCurrentPosition((pos) => {
          console.log("Web 定位:", pos.coords.latitude, pos.coords.longitude);
          Toast.fail(pos.coords.latitude+"1111");

        });
  }
      
    },
    //watchPostion 成功回调
    // onSuccess() {
    //   return (position) => {
    //     console.log(position);
    //     if (position.coords.accuracy >= 20) {
    //       Toast.fail("当前位置定位精度过低");
    //     } else {
    //       this.lat = position.coords.latitude;
    //       this.lng = position.coords.longitude;
    //       this.accuracy = position.coords.accuracy;
    //       this.altitude = position.coords.altitude;
    //       this.latitude = position.coords.latitude;
    //       this.longitude = position.coords.longitude;
    //       this.mymarkPosition(
    //         position.coords.longitude,
    //         position.coords.latitude
    //       );
    //     }
    //   };
    // },

    onSuccess(position) {
      console.log("✅ Position information:",position);
      console.log("✅ Latitude:", position.coords.latitude);
      console.log("✅ Longitude:", position.coords.longitude);
    },

    mymarkPosition(lng, lat) {
      if (this.markerTagObject) {
        this.markerTagObject.setLngLat([lng, lat]);
      } else {
        let elWrap = document.createElement("div");
        elWrap.className = "marker-wrap";
        let elTitle = document.createElement("div");
        elTitle.className = "mymarker";
        var rotateString = "rotate(" + this.curDeg + "deg)";
        elTitle.style.transform = elTitle.style.transform + rotateString;
        elWrap.appendChild(elTitle);
        this.markerTagObject = new mapboxgl.Marker(elWrap)
          .setLngLat([lng, lat])
          .addTo(this.mapInstant);
        this.mymarkobj = elWrap;
        this.mymark = elTitle;
      }
    },
    //watchPostion 失败回调
    onError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("用户拒绝访问定位");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("无法获取位置信息");
          break;
        case error.TIMEOUT:
          console.error("定位超时");
          break;
        default:
          console.error("未知错误:", error.message);
      }
    },
    renewMarker(msg) {
      // this.markerTagObject = null;
      // this.mymarkobj = null;
      // this.mymark = null;
      const { itemlist, data, side } = msg;
      console.log("renewMarker", msg);
      if (!data) {
        return;
      }
      if (!(data.id.includes("Province") || data.id.includes("Record"))) {
        return;
      }
      //经纬度不存在
      if (!data.Lat) {
        Toast.fail("当前区域经纬度未知");
        return;
      }

      //重新调整经纬度
      // this.mapInstant = new mapboxgl.Map({
      //   container: "map-container",
      //   style: "mapbox://styles/mapbox/satellite-streets-v10",
      //   zoom: 13,
      //   center: [data.Lon, data.Lat]
      // });
      this.mapInstant.setCenter([data.Lon, data.Lat]);
      var language = new MapboxLanguage({ defaultLanguage: "zh" });
      this.mapInstant.addControl(language);
      //禁用鼠标右键旋转
      this.mapInstant.dragRotate.disable();
      this.mapInstant.touchZoomRotate.disableRotation();
      //瓦片区域
      //console.log(data.url);
      if (data.tilesetId) {
        //需要判断当前有没有瓦片，如果有需要清空并且加载新的瓦片
        var layers = this.mapInstant.getStyle().layers;
        var firstSymbolId;
        for (var i = 0; i < layers.length; i++) {
          if (layers[i].type === "symbol") {
            firstSymbolId = layers[i].id;
            break;
          }
        }

        //  if(this.mapInstant.getSource("wms-test-layer"+this.curSource)){
        //    this.mapInstant.removeSource("wms-test-layer"+this.curSource)
        //  }
        //  if(this.mapInstant.getLayer("wms-test-layer"+this.curSource)){
        //    this.mapInstant.removeLayer("wms-test-layer"+this.curSource)
        //  }

        // if(this.curSource.indexOf(data.recordId)!=-1){
        //   return;
        // }else {
        //   this.curSource.push(data.recordId)
        // }
        // this.curSource.map((item)=>{
        //   if (this.mapInstant.getSource("wms-test-layer" + item)) {
        //       this.mapInstant.removeSource("wms-test-layer" + item);
        //     }
        //     if (this.mapInstant.getLayer("wms-test-layer" + item)) {
        //       this.mapInstant.removeLayer("wms-test-layer" + item);
        //     }
        // })
        if (this.mapInstant.getLayer("wms-test-layer")) {
          this.mapInstant.removeLayer("wms-test-layer");
        }
        if (this.mapInstant.getSource("wms-test-layer")) {
          this.mapInstant.removeSource("wms-test-layer");
        }
        this.mapInstant.addSource("wms-test-layer", {
          type: "raster",
          tiles: [`https://app.zhengchunlin.com/services/${data.tilesetId}/tiles/{z}/{x}/{y}.png`],
          tileSize: 256,
          minzoom: 0,
          maxzoom: 22
        });


        this.mapInstant.addLayer({
          id: "wms-test-layer",
          type: "raster",
          source: "wms-test-layer",
        },firstSymbolId);
        if (this.svgflag) {
          this.mapInstant.addImage("sh1", this.$refs.sh1);
          this.mapInstant.addImage("sh2", this.$refs.sh2);
          this.mapInstant.addImage("sh3", this.$refs.sh3);
          this.mapInstant.addImage("sh4", this.$refs.sh4);
          this.svgflag = false;
        }

        //严格一对一加载模式

        //清除上一次的标记，添加新的标记
        if (this.curLayers.indexOf(data.recordId) != -1) {
          return;
        } else {
          this.curLayers.push(data.recordId);
        }
        this.curLayers.map((item) => {
          if (this.mapInstant.getLayer("songPointLayer" + item)) {
            this.mapInstant.removeLayer("songPointLayer" + item);
          }
          if (this.mapInstant.getSource("pointLayer" + item)) {
            this.mapInstant.removeSource("pointLayer" + item);
          }
        });

        this.getRecordPoint(data.recordId);

        // item.map(item => {
        //   this.curLayers.push(item);
        // });

        //////
        //修改渲染瓦片的方法
        // this.mapInstant.on("load", async () => {
        //   var layers = this.mapInstant.getStyle().layers;
        //   var firstSymbolId;
        //   for (var i = 0; i < layers.length; i++) {
        //     if (layers[i].type === "symbol") {
        //       firstSymbolId = layers[i].id;
        //       break;
        //     }
        //   }
        //   if(item.length==0){
        //     return;
        //   }
        //   //渲染瓦片

        // });
      }
    },
    getRecordPoint(id) {
      let param = {
        recordId: id,
      };
      searchMarkInfo(param).then((res) => {
        this.markList = res.data.data;
        this.$store.commit("updateList", res.data.data);
        if (res.data.code === 600) {
          this.geojson.data.features = res.data.data.map((item) => {
            const config = {
              1: `sh1`,
              2: `sh2`,
              3: `sh3`,
              4: `sh4`,
            };
            item.icon = config[item.markerLevel];
            return {
              type: "Feature",
              properties: {
                ...item,
              },
              geometry: {
                type: "Point",
                coordinates: [item.markerLon, item.markerLat],
              },
            };
          });
          this.mapInstant.addSource("pointLayer" + id, this.geojson);
          this.geojson.data.features.forEach((item) => {
            if (!this.mapInstant.getLayer("songPointLayer" + id)) {
              this.mapInstant.addLayer({
                id: "songPointLayer" + id,
                type: "symbol",
                source: "pointLayer" + id,
                paint: {
                  "text-color": "#fff" /* 文本颜色 */,
                  "text-halo-width": 2 /* 字体光晕宽度 */,
                  "text-halo-color": "rgba(0, 0, 0, 0.85)" /* 字体光晕颜色 */,
                },
                filter: ["==", "$type", "Point"],
                layout: {
                  "icon-image": "{icon}",
                  "icon-size": 1,
                  "symbol-avoid-edges": true,
                  // 为了让icon全部显示出来 而设置icon和text 可以重叠显示
                  "icon-optional": true,
                  "icon-allow-overlap": true,
                  "icon-ignore-placement": true,
                  "text-optional": true,
                  "text-allow-overlap": true,
                  "text-ignore-placement": true,
                  // end
                  "text-field": "{markerName}",
                  "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                  "text-offset": [0, 1],
                  "text-anchor": "top",
                },
              });
            }
          });
          //监听地图点击时间 添加自定义标记点
          const that = this;
          this.mapInstant.on("click", function (e) {
            if (this.customizeMarker) {
              this.customizeMarker.remove();
            }
            let elWrap = document.createElement("div");
            elWrap.className = "customizeMarker-wrap";
            let elTitle = document.createElement("div");
            elTitle.className = "customizeMarker";
            elWrap.appendChild(elTitle);
            that.customizeMarkerArr = [e.lngLat.lng, e.lngLat.lat];
            that.customizeMarker = new mapboxgl.Marker(elWrap)
              .setLngLat(that.customizeMarkerArr)
              .addTo(that.mapInstant);
            that.showChoice1 = true;
          });
          this.mapInstant.on("click", "songPointLayer" + id, async (e) => {
            this.lat2 = e.features[0].properties.markerLat;
            this.lng2 = e.features[0].properties.markerLon;
            this.markerName = e.features[0].properties.markerName;
            this.getHeight([this.lng2, this.lat2]);
            this.showChoice1 = false;
            this.customizeMarker.remove();
            this.$router.push({
              path: "/picDeatil",
              query: {
                markerId: e.features[0].properties.markerId,
                coord: [this.lat2, this.lng2],
                localCoord: [this.lat, this.lng],
              },
            });
            this.showHeightIcon = true;
          });
        }
      });
    },

    getCurrentPosition(flag) {
      if (flag) {
        console.log(this.lng, this.lat);
        if (this.lng && this.lat) {
          this.mapInstant.setCenter([this.lng, this.lat]);
          this.mapInstant.setZoom(13);
          this.getMarkPosition(this.lng, this.lat);
        } else {
          Toast.fail("当前位置");
        }
      }
    },
    // 为地图两个点画线的方法
    // 需要传输的数据(自身的经纬度，目标的经纬度)
    async addline(lng1, lat1, lng2, lat2) {
      if (lng1 !== null && lng2 !== null) {
        if (this.mapInstant.getSource("route")) {
          this.mapInstant.removeLayer("route");
          this.mapInstant.removeSource("route");
        }
        if (this.mapInstant.getLayer("route")) {
          this.mapInstant.removeLayer("route");
        }
        this.mapInstant.addSource("route", {
          /* addSource()函数添加资源,资源ID是route */
          type: "geojson",
          data: {
            /* GeoJSON格式数据 */
            type: "Feature",
            properties: {},
            geometry: {
              type: "LineString",
              coordinates: [
                [lng1, lat1],
                [lng2, lat2],
              ],
            },
          },
        });

        this.mapInstant.addLayer({
          /* 为地图添加layer */
          id: "route" /* layer id是route */,
          type: "line" /* line类型layer*/,
          source: "route" /* 资源引用的是上面定义的source*/,
          layout: {
            "line-join": "round" /* 线条相交的形状 */,
            "line-cap": "round" /* 线条末端形状 */,
          },
          paint: {
            "line-color": "#65bf2b" /* 线条颜色 */,
            "line-width": 3 /* 线条宽度 */,
          },
        });
      } else {
        return;
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.scrollTop = scrollTop;
      }
    },
    //maobox移除线
    removeline() {
      if (this.mapInstant.getSource("route")) {
        this.mapInstant.removeLayer("route");
        this.mapInstant.removeSource("route");
      }
      if (this.mapInstant.getLayer("route")) {
        this.mapInstant.removeLayer("route");
      }
    },
    //取消当前位置和目标位置连线
    canceldistance() {
      this.canceldistance1 = true;
      this.showDistance = false;
      this.removeline();
    },
    whetherPaint(status) {
      if (status) {
        this.showDistance = true;
        this.addline(this.lng, this.lat, this.lng2, this.lat2); //划线
        this.getDistance(this.lat, this.lng, this.lat2, this.lng2); //获取距离
      } else {
        this.removeline();
      }
    },
    // 根据经纬度计算二点之间的距离
    getRad(d) {
      return (d * this.PI) / 180.0;
    },
    getDistance(lat1, lng1, lat2, lng2) {
      var radLat1 = this.getRad(lat1);
      var radLat2 = this.getRad(lat2);
      var a = radLat1 - radLat2;
      var b = this.getRad(lng1) - this.getRad(lng2);

      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * this.EARTH_RADIUS;
      s = parseInt(Math.round(s * 10000) / 10000.0);
      this.distance = s;
    },
    //旋转标记
    rotateMark(el) {
      el.style.transform = "rotate(" + this.curDeg + "deg)";
    },
    //根据得到的地理位置创建mark标记
    getMarkPosition(lng, lat) {
      this.markerTagObject.setLngLat([lng, lat]);

      // if (this.markerTagObject) {
      //   this.markerTagObject.setLngLat([lng, lat]);
      // } else {
      //   let elWrap = document.createElement("div");
      //   elWrap.className = "marker-wrap";
      //   let elTitle = document.createElement("div");
      //   elTitle.className = "mymarker";
      //   var rotateString = "rotate(" + this.curDeg + "deg)";
      //   elTitle.style.transform = elTitle.style.transform + rotateString;
      //   elWrap.appendChild(elTitle);
      //   this.markerTagObject = new mapboxgl.Marker(elWrap)
      //     .setLngLat([lng, lat])
      //     .addTo(this.mapInstant);
      //   this.mymarkobj = elWrap;
      //   this.mymark = elTitle;
      // }
    },
    getlocalHeight() {
      this.showHeight = true;
      this.difference = this.markerHeight - this.altitude;
      if (this.markerHeight > this.altitude) {
        this.difference = this.markerHeight - this.altitude;
        this.tip = `当前位置比${this.markerName}海拔低${this.difference}米`;
      } else {
        this.difference = this.altitude - this.markerHeight;
        this.tip = `当前位置比${this.markerName}海拔高${this.difference}米`;
      }
    },
    async getHeight(value) {
      //需要注意value的值为数组，两个值，前面为经度，后面为纬度
      var getElevation = MapboxElevation(this.accessToken);
      getElevation(value, (err, elevation) => {
        if (err) throw err;
        this.markerHeight = parseInt(elevation).toString();
      });

      return getElevation;
    },
    cancelMarker() {
      this.showChoice1 = false;
      this.customizeMarker.remove();
    },
  },
  computed: {
    roadflag() {
      return this.$router.meta.roadflag;
    },
    position() {
      return this.$route.query.position;
    },
  },
  mounted() {
    //获取页面高度
    window.addEventListener("scroll", this.handleScroll);
    const inp = document.getElementsByTagName("input");
    Array.from(inp).map((item) => {
      item.onblur = () => {
        window.scrollTo(0, 0);
      };
      item.onfocus = () => {
        window.scrollTo(0, this.scrollTop);
      };
    });
    //初始化mapbox
    getMapToken().then((res) => {
      if (res.data.code === 600) {
        mapboxgl.accessToken = res.data.data.tokenContent;
        this.accessToken = res.data.data.tokenContent;
        this.mapInstant = new mapboxgl.Map({
          container: "map-container",
          style: "mapbox://styles/mapbox/satellite-streets-v10",
          zoom: 13,
          center: [this.longitude, this.latitude],
        });

        var language = new MapboxLanguage({ defaultLanguage: "zh" });
        this.mapInstant.addControl(language);
        this.mapInstant.dragRotate.disable();
        this.mapInstant.touchZoomRotate.disableRotation();
        var scale = new mapboxgl.ScaleControl({
          maxWidth: 80,
          unit: "imperial",
        });

        this.mapInstant.addControl(scale);
        scale.setUnit("metric");
        //添加指南针的事件-----------------------
        var alpha = "";
        var ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) {
          let throttled = _.throttle((e) => {
            this.curDeg = Math.round(360 - e.alpha);
            if (this.mymark) {
              this.rotateMark(this.mymark);
            }
          }, 100);
          window.addEventListener(
            "deviceorientationabsolute",
            throttled,
            false
          );

          //防抖函数
          let throttled1 = _.throttle((e) => {
            if (
              this.$store.state.position === true &&
              this.canceldistance1 != true
            ) {
              this.addline(this.lng, this.lat, this.lng2, this.lat2);
              this.getDistance(this.lat, this.lng, this.lat2, this.lng2); //获取距离
            }
          }, 1000);
          window.addEventListener(
            "deviceorientationabsolute",
            throttled1,
            false
          );
        } else {
          let throttled = _.throttle((e) => {
            this.curDeg = -e.webkitCompassHeading;
          }, 100);
          window.addEventListener(
            "updateDistances",
            DeviceOrientationHandler,
            false
          );

          function DeviceOrientationHandler(event) {}
        }
        if (this.$store.state.lastNode && !this.$store.state.position) {
          this.renewMarker(this.$store.state.lastNode);
          this.$store.state.lastNode = {};
        }
        this.whetherPaint(this.$store.state.position);
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.51.0/mapbox-gl.css");

.container {
  width: 100%;
  height: 100%;
  position: relative;

  .compass {
    position: relative;

    img {
      width: 100%;
    }

    .pa {
      position: absolute;
      top: 0;
      left: 0;
    }

    .pa_p {
      color: #e46f19;
      font-size: 40px;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }
  }

  .compass-box {
    width: 35%;
    top: 100px;
    right: 0px;
    z-index: 300;
    position: fixed;
  }

  #map-container {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
.marker {
  background-image: url("../assets/songshu.svg");
  background-size: cover;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.col-img {
  width: 100%;
  display: block;
}

.img-container {
  margin-top: 10px;
}

.popup-container {
  width: 70vw;
  height: 100vh;
  background-color: #fff;
}

.positionBtn {
  position: absolute;
  bottom: 100px;
  left: 100px;
  width: 50px;
  height: 50px;
  z-index: 1000;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.mapboxgl-ctrl {
  display: none !important;
}

.mymarker {
  background-image: url("../assets/arrow.png");
  background-size: contain;
  width: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 999;
}

#distanceBox {
  position: fixed;
  left: 15px;
  bottom: 20px;
  z-index: 999;
  color: #e46f19;
  font-size: 28px;
  font-weight: 700;

  span {
    color: hotpink;
  }
}

.canceldistance {
  z-index: 999;
  position: fixed;
  right: 40px;
  bottom: 30px;
  width: 65px;
  height: 65px;
  text-align: center;
  text-shadow: 0px 0px 8px #022d6d;
  line-height: 65px;
  // border: 3px solid red;

  box-sizing: border-box;

  .el-icon-error {
    font-size: 60px;
    color: #ffffff;
  }
}

.getlocal {
  z-index: 999;
  position: fixed;
  right: 30px;
  width: 75px;
  height: 75px;
  text-align: center;
  text-shadow: 0px 0px 8px #022d6d;
  line-height: 75px;
  box-sizing: border-box;

  .el-icon-location {
    font-size: 75px;
    color: #ffffff;
  }
}

.message {
  z-index: 999;
  position: fixed;
  left: 30px;
  top: 140px;
  width: 70px;
  height: 70px;
  text-align: center;
  text-shadow: 0px 0px 8px #49e9e3;
  line-height: 70px;
  box-sizing: border-box;

  .el-icon-question {
    font-size: 68px;
    color: #fff;
  }
}

.container-box {
  height: 4rem;
  overflow: hidden;
  background-color: #fff;

  .box {
    width: 10rem;
    overflow-y: auto;
    overflow-x: hidden;
    height: 4rem;

    li {
      line-height: 1.2rem;
      margin-left: 1.3rem;
    }
  }
}
.localHeight {
  z-index: 999;
  position: fixed;
  right: 25px;
  width: 75px;
  height: 75px;
  text-align: center;
  text-shadow: 0px 0px 8px #022d6d;
  line-height: 75px;
  box-sizing: border-box;
  top: 250px;
}
.customizeMarker {
  background-image: url("../assets/mark.png");
  background-repeat: no-repeat;
  background-size: contain;
  width: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 999;
}
.heightContainer .el-dialog {
  position: absolute !important;
  top: 13vh !important;
  width: 80% !important;
  left: 6vh;
  font-size: 30px;
  text-align: center;
}
.choiceContainer1 .el-dialog {
  position: absolute;
  bottom: -5vh;
  width: 100%;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body {
  padding-left: 0;
  padding-right: 0;
  font-size: 30px;
}
.el-dialog__body span {
  display: inline-block;
  font-size: 30px;
  padding: 15px;
}
.cancel {
  border-top: 6px solid #eeeeee;
  font-size: 30px;
  line-height: 60px;
  text-align: center;
  padding-top: 10px;
}
.el-dialog__title {
  font-size: 30px;
}
.choice {
  width: 100%;
  li {
    text-align: center;
    font-size: 30px;
    line-height: 80px;
    display: block;
    border-top: 1px solid #eeeeee;
  }
  li:first {
    border-top: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map1.vue